import React from "react";
import { Icon, Stack } from "@bookingcom/bui-react";
import { BaggageIconWithCheckmark } from "../BaggageIconWithCheckmark/index.js";
import DollarCircleFillIcon from "@bookingcom/bui-assets-react/streamline/DollarCircleFillIcon.js";
import PlaneTicketReturnIcon from "@bookingcom/bui-assets-react/streamline/PlaneTicketReturnIcon.js";
import styles from "./styles.module.css";
export function CardAncillaries(props) {
    const { checkedBag, cabinBag, personalBag, flexTicket, attributes } = props;
    return (React.createElement(Stack, { attributes: attributes, direction: "row", gap: 1 },
        personalBag && React.createElement(BaggageIconWithCheckmark, { baggageType: "personal" }),
        cabinBag && React.createElement(BaggageIconWithCheckmark, { baggageType: "cabin" }),
        checkedBag && React.createElement(BaggageIconWithCheckmark, { baggageType: "bag" }),
        flexTicket && (React.createElement("div", { className: styles.iconContainer },
            React.createElement(Icon, { className: styles.bagIcon, size: "large", svg: PlaneTicketReturnIcon }),
            React.createElement(Icon, { className: styles.checkmarkIcon, size: "smallest", svg: DollarCircleFillIcon })))));
}
